export const filters = [
    {
        component: 'datepicker-range',
        label: "Data de Criação",
        disabled: false,
        hidden: false,
        style: 'form-sale-dates',
        dateStart: '01/01/2012',
        params: {
            name: 'created_at',
            value: null
        }
    },
    {
        component: 'datepicker-range',
        label: "Data de Atualização",
        disabled: false,
        hidden: false,
        style: 'form-sale-dates',
        dateStart: '01/01/2012',
        params: {
            name: 'updated_at',
            value: null
        }
    },
    {
        component: 'datepicker-range',
        label: "Data de Venda",
        disabled: false,
        hidden: false,
        style: 'form-sale-dates',
        dateStart: '01/01/2012',
        params: {
            name: 'saled_at',
            value: null
        }
    },
    {
		component: 'select-tags',
		ajaxSearch: false,
		label: 'Reservas',
		disabled: false,
		hidden: false,
		load: false,
		itemLabel: 'item',
		searchAble: false,
		multiple: false,
		model: '',
		returnValue: 'value',
		options: [
			{ item: 'Todos', value: 3, id: 0 },
			{ item: 'Com reservas', value: 1, id: 1 },
			{ item: 'Sem reservas', value: 2, id: 2 },
		],
		params: {
			name: 'reserves',
			value: null,
		},
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
	},
    {
        component: 'select-tags',
        label: "Origens",
        disabled: false,
        hidden: false,
        service: 'origins',
        method: 'getOrigins',
        itemLabel: 'label',
        searchAble: true,
        multiple: true,
        serviceParams: [],
        options: [],
        returnValue: 'id',
        params: {
            name: 'origin_id',
            value: null
        },
        requestOnStart: true,
        alreadyRequested: false,
        loading: false,
    },
    {
        component: 'select-tags',
        ajaxSearch: false,
        label: "Canal",
        disabled: false,
        hidden: false,
        service: 'channels',
        method: 'getAllV2',
        itemLabel: 'label',
        searchAble: true,
        multiple: true,
        options: [],
        groupBy: 'type',
        returnValue: 'id',
        serviceParams: [],
        searchEvent: 'channel-next-event',
        params: {
            name: 'channel_id',
            value: null
        },
        requestOnStart: false,
        alreadyRequested: false,
        loading: false,
        openEvent: 'kanban-filter-channel'
    },
    {
        component: 'select-tags',
        label: "Tags",
        disabled: false,
        hidden: false,
        service: 'tag',
        method: 'getTagOptions',
        itemLabel: 'label',
        searchAble: true,
        multiple: true,
        serviceParams: ['tags'],
        options: [],
        returnValue: 'label',
        params: {
            name: 'tags',
            value: null
        },
        requestOnStart: false,
        alreadyRequested: false,
        loading: false,
        openEvent: 'deals-list-tags'
    },
    {
        component: 'select-tags',
        label: "Empreendimentos",
        disabled: false,
        hidden: false,
        service: 'product',
        itemLabel: 'label',
        searchAble: true,
        multiple: true,
        method: 'getProductOptions',
        options: [],
        returnValue: 'id',
        params: {
            name: 'product_id',
            value: null
        },
        requestOnStart: true,
        alreadyRequested: false,
        loading: false,
    },
    {
        component: 'select-tags',
        label: "Etapa",
        disabled: false,
        hidden: false,
        service: 'funnel',
        method: 'getStages',
        itemLabel: 'name',
        searchAble: false,
        multiple: false,
        handler: 'funnelStageHandler',
        options: [],
        returnValue: 'id',
        params: {
            name: 'funnel_stage_id',
            value: null
        },
        requestOnStart: true,
        alreadyRequested: false,
        loading: false,
    },
    {
        component: 'select-tags',
        label: "Status",
        disabled: false,
        hidden: false,
        itemLabel: 'name',
        searchAble: true,
        multiple: true,
        options: [],
        returnValue: 'id',
        params: {
            name: 'funnel_stage_status_id',
            value: null
        },
        requestOnStart: true,
        alreadyRequested: false,
        loading: false,
    },
    {
        component: 'select-tags',
        label: "Ociosidade",
        disabled: false,
        hidden: false,
        service: 'idle',
        method: 'getAllV2',
        itemLabel: 'name',
        searchAble: false,
        multiple: true,
        parse(data) {
            return Object.values(data).map(option => {
                let idle = option
                idle.stage = option.stage && option.stage.name ? option.stage.name : 'Regras atuais'
                idle.status = option.status && option.status.name ? option.status.name : 'Sem status'

                return idle
            })
        },
        options: [],
        returnValue: 'id',
        groupBy: 'status',
        params: {
            name: 'idle_color_v2',
            value: null
        },
        requestOnStart: true,
        alreadyRequested: false,
        loading: false,
    },
    {
        component: 'select-tags',
        label: "Tarefa",
        disabled: false,
        hidden: false,
        load: false,
        itemLabel: 'item',
        searchAble: false,
        multiple: false,
        model: '',
        returnValue: 'value',
        options: [
            { item: 'Todos', value: 2, id: 0 },
            { item: 'Com Tarefas Ativas', value: 1, id: 1 },
            { item: 'Com Tarefas Atrasadas', value: -1, id: 2 },
            { item: 'Sem Tarefas', value: 3, id: 3 }
        ],
        params: {
            name: 'tasks',
            value: null
        },
        requestOnStart: true,
        alreadyRequested: false,
        loading: false,
    },
    {
        component: 'select-tags',
        label: "Responsável",
        disabled: false,
        hidden: false,
        itemLabel: 'item',
        searchAble: true,
        multiple: false,
        options: [
            { item: 'Todos', value: 'allDeals', id: 0 },
            { item: 'Meus Clientes', value: 'myDeals', id: 1 },
            { item: 'Acompanhando', value: 'followingDeals', id: 2 },
            { item: 'Não Atribuídos', value: 'notAssigned', id: 3 },
        ],
        returnValue: 'value',
        params: {
            name: 'owner',
            value: null
        },
        requestOnStart: true,
        alreadyRequested: false,
        loading: false,
    },
    {
        component: 'select-tags',
        label: "Equipe",
        disabled: false,
        hidden: false,
        handler: 'teamHandler',
        service: 'team',
        method: 'getAll',
        itemLabel: 'name',
        searchAble: true,
        multiple: false,
        serviceParams: ['', { nocover: true, per_page: 1000 }],
        options: [],
        returnValue: 'id',
        params: {
            name: 'team_id',
            value: null
        },
        requestOnStart: true,
        alreadyRequested: false,
        loading: false,
    },
    {
        component: 'select-tags',
        label: "Gerente",
        disabled: false,
        hidden: false,
        handler: 'managerHandler',
        itemLabel: 'first_name',
        searchAble: true,
        multiple: false,
        options: [],
        returnValue: 'manager_id',
        params: {
            name: 'manager_id',
            value: ''
        },
        requestOnStart: true,
        alreadyRequested: false,
        loading: false,
    },
    {
        component: 'select-tags',
        label: "Corretor",
        disabled: false,
        hidden: false,
        itemLabel: 'first_name',
        searchAble: true,
        multiple: false,
        options: [],
        returnValue: 'broker_id',
        params: {
            name: 'broker_id',
            value: null
        },
        requestOnStart: true,
        alreadyRequested: false,
        loading: false,
    },
    {
        component: 'select-tags',
        ajaxSearch: true,
        label: 'Usuários',
        disabled: false,
        hidden: false,
        service: 'team',
        method: 'getAll',
        itemLabel: 'first_name',
        searchAble: true,
        multiple: false,
        options: [],
        returnValue: 'id',
        serviceParams: ['list/users', { nocover: true, per_page: 25, page: 1 }],
        params: {
            name: 'user_id',
            value: null,
        },
        requestOnStart: false,
        alreadyRequested: false,
        loading: false,
        openEvent: 'list-filter-users-sdr',
        searchEvent: 'list-search-users-sdr'
    },
]

export const columns = [
    {
        title: 'Código',
        allowedExcept: [],
    },
    {
        title: 'Cliente',
        data: 'customer_name',
        sortable: true,
        allowedExcept: [],
    },
    {
        title: 'Email',
        allowedExcept: [],
    },
    {
        title: 'Telefone',
        allowedExcept: [],
    },
    {
        title: 'Empreendimento',
        data: 'product_name',
        sortable: true,
        allowedExcept: [],
    },
    {
        title: 'Valor',
        data: 'cost',
        sortable: true,
        allowedExcept: [],
    },
    {
        title: 'Tags',
        data: 'tags',
        sortable: false,
        allowedExcept: [],
    },
    {
        title: 'Origem',
        data: 'origin_id',
        sortable: false,
        allowedExcept: [],
    },
    {
        title: 'Canal',
        data: 'deal_channel',
        sortable: false,
        allowedExcept: [],
    },
    {
        title: 'Responsável',
        allowedExcept: ['broker'],
    },
    {
        title: 'Etapa - Status',
        data: 'stage',
        sortable: true,
        allowedExcept: [],
    },
    {
        title: 'Data da venda',
        data: 'saled_at',
        sortable: true,
        allowedExcept: [],
    },
    {
        title: 'Atualização',
        data: 'updated_at',
        sortable: true,
        allowedExcept: [],
    },
    {
        title: '',
        allowedExcept: [],
    },
]